import Experience from "../Experience.js";
import * as THREE from "three/webgpu";

export default class LampSocket {
    constructor() {
        this.experience = new Experience();
        this.scene = this.experience.scene;
        this.resources = this.experience.resources;
        
        this.setTextures();
        this.setGeometry();
        this.setMaterial();
        this.setMesh();
    }
    
    setTextures() {
        this.textures = {
            color: this.resources.items.woodColorTexture,
            normal: this.resources.items.woodNormalTexture,
            arm : this.resources.items.woodARMTexture,
            displacement: this.resources.items.woodDisplacementTexture,
        }


        this.textures.color.colorSpace = THREE.SRGBColorSpace;        
    }
    
    setGeometry() {
        this.geometry = new THREE.BoxGeometry(2, .6, 2, 64, 64, 64);
    }
    
    setMaterial() {
        this.material = new THREE.MeshStandardMaterial({
            map: this.textures.color,
            normalMap: this.textures.normal,
            aoMap : this.textures.arm,
            roughnessMap: this.textures.arm,
            metalnessMap: this.textures.arm,
            displacementMap: this.textures.displacement,
            displacementScale: 0,
            displacementBias: 0
        });
    }
    
    setMesh() {
        this.mesh = new THREE.Mesh(this.geometry, this.material);
        
        this.mesh.position.y = 0.3
        this.mesh.castShadow = true;
        
        this.scene.add(this.mesh);
    }
}